import React from 'react';
import { useForm } from 'react-hook-form';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';
import FormText from '../../../components/FormText/FormText';
import { FORM_TEXT_TYPES } from '../../../components/FormText/types';
import { AnalyticsEvents, trackEvent } from '../../../utils/analytics';

const FormAccountName = () => {
  const { register, handleSubmit, reset, formState } = useForm();
  const account = vars.newAccount();

  const onSubmit = (data: Record<string, string>) => {
    vars.newAccount({ ...account, ...data });
    trackEvent(AnalyticsEvents.NAME_INPUT);

    increaseFormPage();
  };

  return <FormText type={FORM_TEXT_TYPES.NAME} formOptions={{ register, handleSubmit, reset, formState }} onSubmit={onSubmit} />;
};
export default FormAccountName;
